import { IconButton, Tooltip } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import sendRequest from "../../dataProvider/sendRequest";
import useNotify from "../../unit/useNotify";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useRefresh } from "react-admin";
const ExceptionManualProcessed = ({ ...props }) => {
  const record = props.record;
  if (!record) return null;
  const refresh = useRefresh();
  const { successNotify, errorNotify } = useNotify();
  const handleShowTransferExceptionManualProcessed = () => {
    var reqUrl = "repayment/action/manualProcessed";
    var parmId = record.id;
    var response = sendRequest(reqUrl, {
      id: parmId,
      data: {
        filterStatus: props?.filterStatus,
      },
    });
    response
      .then((res) => {
        if (res.code == 200) {
          successNotify("Changed successfully");
          refresh();
        } else {
          errorNotify("Failed to process manually: " + res.message);
        }
      })
      .catch((error) => {
        errorNotify("Error: " + error.message);
      });
  };
  return (
    <>
      <Tooltip title={`Make as reviewed`} placement="left">
        <IconButton
          size="small"
          onClick={handleShowTransferExceptionManualProcessed}
          sx={{ marginLeft: "5px", p: 1 }}
        >
          <DoneAllIcon sx={{ color: "#1976d2" }} />
        </IconButton>
      </Tooltip>
    </>
  );
};
export default ExceptionManualProcessed;
